import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { BackgroundProcessService } from 'src/app/services/background-process.service';
import { NotificationDebugService } from 'src/app/services/notification-debug.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Storage } from '@ionic/storage-angular';
import { StylistService } from 'src/app/services//stylist.service';
import { ENV_CONFIG } from '../bin/env.config';
import { App } from '@capacitor/app';
import { AppLauncher } from '@capacitor/app-launcher';
import { register } from 'swiper/element/bundle';
register();
declare let gtag: Function;
import {
  PopoverController,
  NavController,
  MenuController,
  ModalController,
  ToastController,
  Platform,
  ViewWillEnter,
} from '@ionic/angular';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { NavComponent } from './components/nav/nav.component';
import { Stylist } from './models/stylist/stylist.model';
import { HelpPage } from './help/help.page';
// import * as Sentry from '@sentry/angular';
// const { logger } = Sentry;
import { SubscriptionLike } from 'rxjs';

import { StatusBar, Style } from '@capacitor/status-bar';
const setBackgroundColor = async () => {
  await EdgeToEdge.setBackgroundColor({ color: '#ffffff' });
  await StatusBar.setStyle({ style: Style.Light });
};
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
const enable = async () => {
  await EdgeToEdge.enable();
};
import { Utilities } from './utilities/utilities';
import { BeaconKeyboardLifterService } from './services/beacon-keyboard-lifter.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy, ViewWillEnter {
  pages_1 = [
    {
      title: 'Bookings',
      url: '/bookings',
      icon: 'calendar',
    },
    {
      title: 'Clients',
      url: '/clients',
      icon: 'person',
    },
  ];
  pages_2 = [
    {
      title: 'Sales',
      url: '/sales',
      icon: 'card',
    },
    {
      title: 'Register Closures',
      url: '/register-closures',
      icon: 'cash',
    },
    {
      title: 'Products',
      url: '/products',
      icon: 'pricetags',
      expandable: true,
      children: [
        { title: 'Products', url: '/products' },
        { title: 'Categories', url: '/categories' },
        { title: 'Brands', url: '/brands' },
        { title: 'Suppliers', url: '/suppliers' },
      ],
    },
    {
      title: 'Inventory',
      url: '/inventory',
      icon: 'cube',
      expandable: true,
      children: [
        { title: 'Purchase Orders', url: '/inventory' },
        { title: 'Inventory History', url: '/inventory-history' },
        { title: 'Inventory Count', url: '/inventory-count' },
      ],
    },
    {
      title: 'Marketing',
      url: '/marketing',
      icon: 'send',
      // expandable: true,
      // children: [
      //   {title: 'Email', url: '/marketing'},
      //   {title: 'Text', url: '/text-marketing'},
      // ]
    },
    {
      title: 'Reports',
      url: '/reports',
      icon: 'pie-chart',
      disabled: false,
    },
    {
      title: '',
      url: '',
      icon: '',
      disabled: true,
    },
    {
      title: 'Accept Online Bookings',
      url: '/online-bookings',
      icon: 'desktop',
    },
    {
      title: 'Import Contacts',
      url: '/import-contacts',
      icon: 'receipt',
    },
    {
      title: 'Subscribe to Calendar',
      icon: 'today',
      url: '/subscribe-to-calendar',
    },
    {
      title: '',
      url: '',
      icon: '',
      disabled: true,
    },
    {
      title: 'Settings',
      url: '/settings',
      icon: 'settings',
      disabled: false,
    },
    /*{
      title: 'Help',
      url: '/help',
      icon: 'help',
    },  */
  ];

  user;

  profileImg;

  selectedPath = '';

  bookingWaitListCount = 0;

  bookingRequestCount = 0;

  isLoggedIn = false;

  public collapsed: boolean = false;
  public appVersion: string;
  public stylists: Stylist;
  public loginLastRecorded: number = Date.now();
  public allowSettings: boolean;
  public allowReports: boolean;
  public isNativeApp: boolean;
  public onResumeSubscription: SubscriptionLike | null = null;
  private keyboardSubscription: SubscriptionLike | null = null;

  constructor(
    public router: Router,
    public userService: UserService,
    private backgroundProcessService: BackgroundProcessService,
    private storage: Storage,
    private popoverCtrl: PopoverController,
    private stylistService: StylistService,
    private platform: Platform,
    private inAppBrowser: InAppBrowser,
    private navCtrl: NavController,
    private menuCtrl: MenuController,
    private modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private changeDetectorRef: ChangeDetectorRef,
    private notificationDebugService: NotificationDebugService,
    private notificationService: NotificationService,
    private beaconKeyboardLifter: BeaconKeyboardLifterService
  ) {
    this.appVersion = ENV_CONFIG.appVersion;
    this.isNativeApp = this.platform.is('hybrid');

    // Initialize status bar settings
    if (this.isNativeApp) {
      // Set the background color of the status bar to white and text to black
      setBackgroundColor();
      // Handle app resume
      App.addListener('resume', () => {
        // Only refresh if we've been away for more than 5 minutes
        // logger.info('APP RESUMED in app.component.ts');
        const now = Date.now();
        if (now - this.loginLastRecorded > 5 * 60 * 1000) {
          this.loginLastRecorded = now;
          // logger.info(
          //   '5 minutes have passed so we are refreshing user data in app.component.ts via App.addListener'
          // );
          // Refresh only necessary data
          this.userService.refreshUserData();
        }
      });
    }

    this.router.events.subscribe((event: RouterEvent) => {
      if (event && event.url) {
        this.selectedPath = event.url;
      }
      if (event instanceof NavigationEnd) {
        // track google analytics page views
        gtag('config', 'G-MFKK9R8PZ9', {
          page_path: 'app' + event.urlAfterRedirects,
        });
      }
    });

    this.allowSettings = this.pages_2.find(
      (x) => x.title == 'Settings'
    ).disabled;
    // this.allowReports = this.pages_2.find(x=>x.title == 'Reports').disabled;

    /*if((this.stylists.canViewReports === 0) || (this.stylists.settingsControl === 0)){
      this.allowSettings = false;
      this.allowReports = false;
      //this.pages_2.find(x=>x.title == 'Settings').disabled = true;
      //this.pages_2.find(x=>x.title == 'Reports').disabled = true;
    }*/
  }

  async ngOnInit() {
    this.isLoggedIn = this.userService.isLoggedIn();
    this.beaconKeyboardLifter.init();
    this.attachGlobalErrorLogging();
    this.userService.profileImageMonitor$.subscribe((data) => {
      this.profileImg = ENV_CONFIG.STAFF_THUMBNAIL_PHOTO_ROOT + '/' + data;
      // Handle data change in AppComponent
    });
    await this.storage.create();
    this.storage.set('collapsed', false);
    this.userService.getLogInMonitor().subscribe((login) => {
      if (login) {
        this.isLoggedIn = login;
        // this.stylistService.recordStylistActivity(
        //   this.userService.getUser().getID(),
        //   'First Load'
        // );
        if (this.userService.getUser()) {
          this.user = this.userService.getUser();
          //canViewReports == 1
          //settingsControl ==1
          if (this.userService.getUser().getFullThumbnailUrl()) {
            this.profileImg = this.userService.getUser().getFullThumbnailUrl();
          }
          // this.stylistService.recordStylistActivity(
          //   this.userService.getUser().getID(),
          //   'First Load'
          // );
        }
        
          // Register device for notifications when user logs in
          if (Utilities.isCapacitorNative() && login) {
            // Small delay to ensure user data is fully set
            setTimeout(async () => {
              (await this.notificationService.registerDevice()).subscribe();
            }, 500);
          }
      }
    });

    this.backgroundProcessService.bookingRequestMonitor$.subscribe(
      (bookingRequestCount: number) => {
        this.bookingRequestCount = bookingRequestCount;
      }
    );

    this.backgroundProcessService.bookingWaitListMonitor$.subscribe(
      (bookingWaitListCount: number) => {
        this.bookingWaitListCount = bookingWaitListCount;
      }
    );

    // Initialize notification system
    if (Utilities.isCapacitorNative()) {
      // Initialize notification service (requests permissions, sets up listeners, registers device if logged in)
      this.notificationService.initialize().catch((error) => {
        console.error('[APP] Error initializing notification service:', error);
      });
    }

    // // activate Sentry
    // Sentry.init({
    //   dsn: ENV_CONFIG.SENTRY_DSN,
    //   environment: ENV_CONFIG.SENTRY_ENVIRONMENT,
    //   // release: ENV_CONFIG.appVersion,
    //   integrations: [
    //     // Registers and configures the Tracing integration,
    //     // which automatically instruments your application to monitor its
    //     // performance, including custom Angular routing instrumentation
    //     Sentry.browserTracingIntegration(),
    //     Sentry.replayIntegration({
    //       maskAllText: false,
    //       blockAllMedia: false,
    //     }),
    //   ],

    //   // Set tracesSampleRate to 1.0 to capture 100%
    //   // of transactions for performance monitoring.
    //   // We recommend adjusting this value in production
    //   tracesSampleRate: 0.2,

    //   // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    //   tracePropagationTargets: [
    //     'localhost',
    //     /^https:\/\/api.salonmonster\.com\/api/,
    //     /^https:\/\/api2.salonmonster\.com\/api/,
    //     /^https:\/\/api3.salonmonster\.com\/api/,
    //     /^https:\/\/api4.salonmonster\.com\/api/,
    //   ],

    //   // Capture Replay for 10% of all sessions,
    //   // plus for 100% of sessions with an error
    //   replaysSessionSampleRate: 1.0,
    //   replaysOnErrorSampleRate: 1.0,
    //   _experiments: { enableLogs: true },
    // });
    // Sentry.captureMessage('Something went wrong', 'warning');

    // Rely on Capacitor Keyboard resize (configured in capacitor.config.json)
  }

  // Removed custom keyboard handling; we use Capacitor Keyboard resize instead

  public ngOnDestroy() {
    if (this.onResumeSubscription) {
      this.onResumeSubscription.unsubscribe();
      this.onResumeSubscription = null;
    }
    
    if (this.keyboardSubscription) {
      this.keyboardSubscription.unsubscribe();
      this.keyboardSubscription = null;
    }

    // No keyboard listeners to remove
    this.beaconKeyboardLifter.destroy();
  }

  public ionViewWillEnter() {
    // logger.info('ionViewWillEnter in app.component.ts');
    // if (this.platform.is('capacitor')) {
    //   logger.info('platform.is(capacitor) in app.component.ts');
    //   this.platform.ready().then(() => {
    //     logger.info('platform.ready in app.component.ts');
    //     // Unsubscribe from any existing subscription
    //     if (this.onResumeSubscription) {
    //       this.onResumeSubscription.unsubscribe();
    //     }
    //     this.onResumeSubscription = this.platform.resume.subscribe(() => {
    //       logger.info(
    //         'onResumeSubscription activated in app.component.ts via this.onResumeSubscription'
    //       );
    //       // Only mark for check if we're actually logged in
    //       if (this.isLoggedIn) {
    //         logger.info('resuming as isLoggedIn in app.component.ts');
    //         this.changeDetectorRef.markForCheck();
    //       }
    //     });
    //   });
    // } else {
    //   logger.info('Platform is not capacitor in app.component.ts');
    // }
  }

  private attachGlobalErrorLogging() {
    try {
      const w: any = window as any;
      if (w.__smGlobalErrorHandlersAttached) {
        return;
      }
      w.__smGlobalErrorHandlersAttached = true;
      window.addEventListener('error', (event: ErrorEvent) => {
        const err = event?.error;
        console.error('[GlobalError]', event?.message, event?.filename, event?.lineno, event?.colno, err?.stack || err);
      });
      window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
        console.error('[UnhandledRejection]', event?.reason);
      });
    } catch (_) {
      // noop
    }
  }

  public async popover(ev, page) {
    const popover = await this.popoverCtrl.create({
      component: NavComponent,
      event: ev,
      componentProps: {
        options: page.children,
      },
    });
    popover.present();
  }

  public collapseMenu() {
    this.collapsed = !this.collapsed;
    this.storage.set('collapsed', this.collapsed);
  }

  public logout() {
    this.isLoggedIn = false;
    this.userService.logout();
  }

  public open(url) {
    if (url == 'https://salontastic.salonmonster.com') {
      window.location = url;
      return;
    }
    this.navCtrl.setDirection('root');
    this.router.navigateByUrl(url);
    this.menuCtrl.toggle();
  }

  public onSubscribeToCalendar() {
    // Trigger native calendar subscription on iOS via webcal://
    // Uses Capacitor AppLauncher when available (avoids deprecated iOS APIs),
    // falls back to Cordova InAppBrowser with _system, then to window.location for web.
    //this.collapseMenu()
    const user = this.userService.getUser();
    const salon = this.userService.getSalon();

    if (user && salon) {
      const stylistKey = user.getStylistKey();

      if (!stylistKey || stylistKey.length === 0) {
        return;
      }

      const link =
        'webcal://' +
        'salonmonster.com/live/feed/ical.php?calendar=' +
        stylistKey.substr(0, 20);

      // Always try Capacitor AppLauncher first, even if platform reports Cordova
      const fallback = () => {
        if (this.platform.is('cordova')) {
          try {
            this.inAppBrowser.create(link, '_system');
          } catch (err) {
            window.location.href = link;
          }
        } else {
          window.location.href = link;
        }
      };

      AppLauncher.canOpenUrl({ url: link })
        .then((res) => {
          if (res && res.value) {
            AppLauncher.openUrl({ url: link })
              .catch(() => fallback());
          } else {
            fallback();
          }
        })
        .catch(() => fallback());
      return;
    }
  }
  public async onClickHelp() {
    const modal = await this.modalCtrl.create({
      component: HelpPage,
    });
    return await modal.present();
  }

  public onReload() {
    // This reloads the app's index.html page with a random query string to force it to reload from the server (not cache)
    var randomNumber = Math.floor(Math.random() * 1000000000); // Generates a random number
    var base = window.location.href.split('#')[0]; // Get the base URL before the hash
    var newUrl = base.replace(/\/$/, '') + '/index.html?update=' + randomNumber; // Append 'index.html' with the update parameter
    window.location.href = newUrl; // Redirect to the new URL
  }
}
